export default __webpack_public_path__ + "static/media/ppmcloud_01_y.f0b275b0.png";